import { isMsalEnabledForBusiness } from 'owa-msaljs/lib/isMsalEnabledForBusiness';
import { isAnonymousSession } from 'owa-msaljs/lib/isAnonymousSession';
import { isAnonymousUser as isAnonymousUserOld } from 'owa-config/lib/anonymousUtils';
import { getQueryStringParameters } from 'owa-querystring';
import { getWindowData } from 'owa-window-data';

export function isAnonymousUser(): boolean {
    const queryStringValues = getQueryStringParameters(getWindowData().location);
    if (isMsalEnabledForBusiness() && hasMSALJsQueryParam(queryStringValues)) {
        return isAnonymousSession();
    }

    return isAnonymousUserOld();
}

function hasMSALJsQueryParam(queryStringKV: {}) {
    return Object.keys(queryStringKV).indexOf('ismsaljsauthenabled') >= 0;
}
